'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { ArrowRight, Sparkles, Gift, MapPin } from 'lucide-react';
const highlights = [{
  icon: Sparkles,
  label: 'Discover new products'
}, {
  icon: Gift,
  label: 'Score free samples'
}, {
  icon: MapPin,
  label: 'Find experiences near you'
}];
export function ConsumerDiscoverSection() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="mb-4 text-3xl font-extrabold leading-tight text-gray-900 sm:text-4xl">Just wanting to discover and try products?</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="py-16 lg:py-20"><div className="container mx-auto px-4 sm:px-6 lg:px-8"><div className="mx-auto max-w-3xl text-center">{t0}<Link href="/consumer/discover-do" className="group inline-flex cursor-pointer items-center gap-2 rounded-full bg-primary-600 px-8 py-4 text-base font-bold text-white shadow-lg shadow-primary-200/50 transition-all hover:bg-primary-700 hover:shadow-xl">Discover<ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></Link></div></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function BusinessMarketplaceHeading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="container mx-auto px-4 py-8 text-center sm:px-6 lg:px-8"><h2 className="mx-auto max-w-3xl text-xl font-extrabold leading-tight text-gray-900">Sizzle is mostly for brands, retailers, agencies, providers, and hosts to be inspired, discover, and connect with opportunities.</h2></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}